module.exports = __webpack_public_path__ + "img/banner_en.e40a8dd9.jpeg";